// extracted by mini-css-extract-plugin
export default {"input":"Search_input__klILD","search-box":"Search_search-box__8pNsY"};